// src/pages/Galerie.js
import React, { useState, useEffect, useCallback, useRef } from "react";
import useSEO from "../seo/useSEO";

const photos = Array.from({ length: 45 }, (_, i) => `/images/gallery/photo${i + 1}.jpg`);

export default function Galerie() {
  useSEO({
    title: "Galerie — HLBK Photographe",
    description: "Découvrez une sélection de portraits, mariages, événements et reportages photo.",
    canonical: `${window.location.origin}/galerie`,
    image: "/images/og-default.jpg",
  });

  const [current, setCurrent] = useState(null); // index ou null
  const startX = useRef(null);

  const open  = useCallback((i) => setCurrent(i), []);
  const close = useCallback(() => setCurrent(null), []);
  const next  = useCallback(
    () => setCurrent((i) => (i === null ? 0 : (i + 1) % photos.length)),
    []
  );
  const prev  = useCallback(
    () => setCurrent((i) => (i === null ? 0 : (i - 1 + photos.length) % photos.length)),
    []
  );

  // ESC / flèches clavier
  useEffect(() => {
    const onKey = (e) => {
      if (current === null) return;
      if (e.key === "Escape") close();
      if (e.key === "ArrowRight") next();
      if (e.key === "ArrowLeft") prev();
    };
    document.addEventListener("keydown", onKey);

    if (current !== null) {
      const old = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = old;
        document.removeEventListener("keydown", onKey);
      };
    }
    return () => document.removeEventListener("keydown", onKey);
  }, [current, close, next, prev]);

  // Swipe mobile
  const onTouchStart = (e) => (startX.current = e.touches[0].clientX);
  const onTouchEnd = (e) => {
    if (startX.current == null) return;
    const dx = e.changedTouches[0].clientX - startX.current;
    if (Math.abs(dx) > 40) (dx < 0 ? next : prev)();
    startX.current = null;
  };

  return (
    <section className="section">
      {/* Grille 3 colonnes responsive */}
      <div className="gallery">
        {photos.map((src, i) => (
          <figure key={src} className="gallery-item" onClick={() => open(i)}>
            {/* Image décorative -> alt vide + aria-hidden */}
            <img src={src} alt="" aria-hidden="true" loading="lazy" />
          </figure>
        ))}
      </div>

      {/* Lightbox */}
      {current !== null && (
        <div className="modal" onClick={close}>
          <button
            className="lb-close"
            aria-label="Fermer"
            onClick={(e) => { e.stopPropagation(); close(); }}
          >
            ×
          </button>

          <button
            className="lb-arrow lb-prev"
            aria-label="Précédent"
            onClick={(e) => { e.stopPropagation(); prev(); }}
          >
            ‹
          </button>

          <div
            className="modal-inner"
            onClick={(e) => e.stopPropagation()}
            onTouchStart={onTouchStart}
            onTouchEnd={onTouchEnd}
          >
            {/* Image décorative en plein écran -> alt vide + aria-hidden */}
            <img src={photos[current]} alt="" aria-hidden="true" />
            <div className="lb-caption">© HLBK — Photo {current + 1}/{photos.length}</div>
          </div>

          <button
            className="lb-arrow lb-next"
            aria-label="Suivant"
            onClick={(e) => { e.stopPropagation(); next(); }}
          >
            ›
          </button>
        </div>
      )}
    </section>
  );
}